import { Dispatch } from 'react'
import { AnyAction } from '@reduxjs/toolkit'
import { addDishSection, setRestaurant } from '@pages/OwnerPersonalPage/model/OwnerPostsModel/slice'
import { loadRestWithPosts, postUpdate } from '@pages/OwnerPersonalPage/model/OwnerPostsModel/thunks'
import { globalStore, RootState, AppDispatch } from '@app/model/store'
import { addTemporaryNotice } from '@widgets/Common/Notices'
import { TypeFormCreatePost, TypeFormEditPost } from './types'

export const initPostsPage = (restaurant: { id: number; name: string }) => async (dispatch: AppDispatch) => {
  dispatch(setRestaurant(restaurant))
  await dispatch(loadRestWithPosts() as any)
}

export const addDishSectionAC =
  () =>
  (dispatch: AppDispatch): AnyAction => {
    const state = globalStore.getState() as RootState
    const statePosts = state.pages.owner_personal.posts

    // узнаем какая форма открыта сейчас (создание или редактирование)
    const typeForm = statePosts.forms.selectedForm
    if (typeForm === 'delete') return { type: 'NO_ACTION' }

    // Если элементов уже 10, то больше не добавляем
    const currentForm = statePosts.forms[typeForm] as TypeFormCreatePost | TypeFormEditPost
    const currentDishes = currentForm.categories.menu.fields.dishes
    if (currentDishes.length >= 3) return { type: 'NO_ACTION' }

    // Если поля последнего элемента не заполнены, то не даем создать новый
    const allFieldsIsValid = Object.values(currentDishes[currentDishes.length - 1]).every((el) => {
      if (typeof el === 'object' && el !== null && 'value' in el) {
        return !!el.value
      }
      return true
    })

    if (allFieldsIsValid) {
      return dispatch(addDishSection())
    } else {
      dispatch(addTemporaryNotice({ markup: 'Поля у предыдущего блюда не заполнены' }) as any)
      return { type: 'NO_ACTION' }
    }
  }

export const postCreate = postUpdate
export const postEdit = postUpdate
